import React, { useState, useEffect } from "react"
import { Row, Col, Select, Image } from 'antd'
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next"
import { useEventsMap } from '../../hooks/useEvents'
import Card from './CardComponent'
import { GeneralProps } from "../../services/props"
import utils from '../../utils'
import classes from "./styles.module.css"
import { useLocation } from "react-router-dom"
import Spinner from '../../common/Spinner'
import HelmetComponent from '../../components/Helmet'

import bgimg1 from '../../img/events.jpg';
import micon from '../../img/m_icon.png';

const { Option } = Select

const Events = () => {
  const { t } = useTranslation()

  const { isLoading, Events } = useEventsMap()

  const location = useLocation()
  const [listData, setListData] = useState<GeneralProps[]>(Events);

  const [type, setType] = useState<string>('Τύπος');
  const [month, setMonth] = useState<string>('Μήνας');
  const [current, setCurrent] = useState<string>(location?.state?.day ? location?.state?.day : '40');
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (current != '40') {
      let data = utils.filterEventsArray(Events, type, month, current)
      setListData(data)
    }
    else {
      setListData(Events)
    }
  }, [Events])

  const handleChange = (key: string, value: string): void => {
    switch (key) {
      case 'type':
        let datas = utils.filterEventsArray(Events, type, month, current)
        setListData(datas)
        setType(value)
        break;

      case 'month':
        setMonth(value);
        break;

      default:
        setCurrent(value)
    }
  };

  const handleChangeTime = (value: string): void => setCurrent(value)

  useEffect(() => {
    let data = utils.filterEventsArray(Events, type, month, current)
    if (type === "Τύπος" && month === "Μήνας" && current === "40") {
      setListData(Events)
    } else {
      setListData(data)
    }
  }, [type, month, current])

  if (isLoading) { return <Spinner /> }

  return (
    <>
      <HelmetComponent title={t('SEO Events title')} descrition={t('SEO Events description')} />

      <div className={classes.headerTitleContainer}> 
        <div className={classes.headerTitle}>
          <span>
            <img src={micon} alt="banner-icon" className={classes.micon}/>
            <h2>{t('Εκδηλώσεις')}</h2>
          </span>
          <h2 className={classes.headerText}>{t('Συμμετάσχετε στις εκδηλώσεις μας, ελάτε να γνωριστούμε')}</h2>
        </div>
        <img className={classes.headerImage} src={bgimg1} alt='museum-banner-img'/>       
      </div>

      <div className={classes.eventsPageContainer}>
        <Row className={classes.filters}>
          <Col xs={7} sm={7} lg={3} xl={3}>
            <Select
              placeholder={t("EventsAll")}
              className={classes.type}
              size={'large'}
              placement="bottomLeft"
              showArrow={false}
              defaultValue={'Τύπος'}
              autoClearSearchValue={false}
              onChange={(e) => handleChange("type", e)} >

              <Option value="Τύπος" className={'ant-option'}>{t("Τύπος")} <RightOutlined /></Option>
              <Option value="Κινηματογράφος" className={'ant-option'}>Κινηματογράφος</Option>
              <Option value="Εργαστήριο" className={'ant-option'}>Εργαστήριο</Option>
              <Option value="Εκδηλώσεις" className={'ant-option'}>Εκδηλώσεις</Option>
              <Option value="Συναυλίες" className={'ant-option'}>Συναυλίες</Option>
              <Option value="Χορός" className={'ant-option'}>Χορός</Option>
              <Option value="Έκθεση" className={'ant-option'}>Έκθεση</Option>
              <Option value="Θέατρο" className={'ant-option'}>Θέατρο</Option>
              <Option value="Ρεσιτάλ" className={'ant-option'}>Ρεσιτάλ</Option>
              <Option value="Συνέδριο" className={'ant-option'}>Συνέδριο</Option>
            </Select>
          </Col>

          <Col xs={7} sm={7} lg={3} xl={3}>
            <Select
              placeholder={t("Μήνας")}
              className={classes.month}
              size={'large'}
              defaultValue={'Μήνας'}
              showArrow={false}
              autoClearSearchValue={false}
              onChange={(e) => handleChange("month", e)} >

              <Option value="Μήνας" className={'ant-option'}>{t("Μήνας")} <RightOutlined /></Option>
              <Option value="Jan" className={'ant-option'}>{t("Ιανουάριος")}</Option>
              <Option value="Feb" className={'ant-option'}>{t("Φεβρουάριος")}</Option>
              <Option value="Mar" className={'ant-option'}>{t("Μάρτιος")}</Option>
              <Option value="Apr" className={'ant-option'}>{t("Απρίλιος")}</Option>
              <Option value="May" className={'ant-option'}>{t("Μάιος")}</Option>
              <Option value="Jun" className={'ant-option'}>{t("Ιούνιος")}</Option>
              <Option value="Jul" className={'ant-option'}>{t("Ιούλιος")}</Option>
              <Option value="Aug" className={'ant-option'}>{t("Αύγουστος")}</Option>
              <Option value="Sep" className={'ant-option'}>{t("Σεπτέμβριος")}</Option>
              <Option value="Oct" className={'ant-option'}>{t("Οκτώβριος")}</Option>
              <Option value="Nov" className={'ant-option'}>{t("Νοέμβριος")}</Option>
              <Option value="Dec" className={'ant-option'}>{t("Δεκέμβριος")}</Option>
            </Select>
          </Col>
          
          <Col xs={7} sm={7} lg={3} xl={3}>
            <Select
              placeholder={t("Ταξινόμηση")}
              className={classes.days}
              size={'large'}
              showArrow={false}
              defaultValue={location?.state?.day ? location?.state?.day : '40'}
              onChange={handleChangeTime} >

              <Option value="40">{t('Ταξινόμηση')}<RightOutlined /></Option>
              <Option value="1">{t('Today')}</Option>
              <Option value="2">{t('Αύριο')}</Option>
              <Option value="7">{t('In a week')}</Option>
              <Option value="30">{t('In a month')}</Option>
            </Select>
          </Col>
        </Row>

        <br />
        {listData && listData.slice(page * 3, 3 * page + 3).map((event: { [index: string]: any }, index: number) => 
          <Row>
            <Card
              id_item={event.id_item}
              styleImage={true}
              type={event.category_type}
              image={event.image}
              event={event.title}
              description={event.description}
              municipality={event.municipality}
              location={event.venues[0]?.title}
              start={event.time_periods[0].starting_date}
              end={event.time_periods[0].ending_date}
              t1={
                event.price.length > 0
                  ? event.price.map((prices: any) => prices.price != 0 && prices.price ? `${prices.description + ' ' + prices.price} € \n` : t("Είσοδος ελεύθερη"))
                  : t("Είσοδος ελεύθερη")
              }
            />
          </Row>
        )}
      </div>
    </>
  )
}

export default Events